import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { StudioComponent } from './pages/studio/studio.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { RouteConstants } from './shared/constants/routes.constants';
import { PublicEsignComponent } from './pages/public-esign/public-esign.component';
import { EsignDocumentListComponent } from './pages/esign-document-list/esign-document-list.component';
import { EsignDashboardComponent } from './pages/esign-dashboard/esign-dashboard.component';
import { environment } from '../environments/environments';
import { LoginGuard } from './guards/login.guard';
import { RedirectionFailureComponent } from './redirection-failure.component';
import { RedirectionSuccessComponent } from './redirection-success.component';

const isEsign = environment.envType === 'ESIGN';
const homeRedirect = isEsign ? RouteConstants.Dashboard : RouteConstants.CategoryList;

const routes: Routes = [
  {
    path: '',
    canActivate: [LoginGuard],
    component: HomeLayoutComponent,
    children: [
      { path: '', redirectTo: homeRedirect, pathMatch: 'full' },
      ...(isEsign
        ? [
            { path: RouteConstants.Dashboard, component: EsignDashboardComponent },
            { path: RouteConstants.ESign, component: PublicEsignComponent },
            { path: RouteConstants.History, component: EsignDocumentListComponent },
            { path: RouteConstants.Wallet, loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletModule) },
          ]
        : [
            { path: RouteConstants.Studio, component: StudioComponent },
            { path: RouteConstants.CategoryList, component: HomeComponent },
          ]
      ),
    ]
  },
  { path: 'redirection-failure', component: RedirectionFailureComponent },
  { path: 'redirection-success', component: RedirectionSuccessComponent },
  { path: RouteConstants.Login, component: LoginComponent },
  { path: '**', redirectTo: RouteConstants.Login, pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
